const ConditionalWrapper = ({ condition, Wrapper, wrapperProps = {}, children }) => {
  if (condition) {
    return <Wrapper {...wrapperProps}>{children}</Wrapper>;
  }

  return children;
};

export default ConditionalWrapper;
